export enum DlpKeywordListModalNameEnum {
  None = 'none',
  Add = 'add',
  Delete = 'delete',
  Import = 'import',
  Edit = 'edit',
}

export type DlpKeywordListModalState =
  | {
      name:
        | DlpKeywordListModalNameEnum.None
        | DlpKeywordListModalNameEnum.Add
        | DlpKeywordListModalNameEnum.Import;
      data: any;
    }
  | {
      name: DlpKeywordListModalNameEnum.Delete;
      data: {
        cfgIndex: string;
        dpKeywordName: string;
        dpKeywordDesc: string;
      };
    }
  | {
      name: DlpKeywordListModalNameEnum.Edit;
      data: {
        cfgIndex: string;
      };
    };

export enum DlpExpressionsModalNameEnum {
  None = 'none',
  Add = 'add',
  Delete = 'delete',
  Import = 'import',
  Edit = 'edit',
}

export type DlpExpressionsModalState =
  | {
      name:
        | DlpExpressionsModalNameEnum.None
        | DlpExpressionsModalNameEnum.Add
        | DlpExpressionsModalNameEnum.Import;
      data: any;
    }
  | {
      name: DlpExpressionsModalNameEnum.Delete;
      data: {
        cfgIndex: string;
        dpExpressionName: string;
        dpExpressionDesc: string;
      };
    }
  | {
      name: DlpExpressionsModalNameEnum.Edit;
      data: {
        cfgIndex: string;
      };
    };

export enum ExpressionCriteriaEnum {
  None = 'Generic',
  SpecificCharacters = 'Type 1',
  Suffix = 'Type 2',
  SingleCharacterSeparator = 'Type 3',
}

export enum KeywordConditionEnum {
  All = 'All',
  Any = 'Any',
  Threshold = 'Threshold',
  Distance = 'Distance',
}
